import React from 'react';
import { CheckCheck } from 'lucide-react';
import { cn } from '../../lib/utils';

export function MessageReadReceipt({ status = 'seen', className }) {
  return (
    <CheckCheck
      className={cn(
        'h-3.5 w-3.5',
        status === 'seen' ? 'text-[#DD0000]' : 'text-zinc-400',
        className
      )}
      strokeWidth={2.5}
      title={status === 'seen' ? 'Lexuar' : 'Dërguar'}
      aria-label={status === 'seen' ? 'Lexuar' : 'Dërguar'}
    />
  );
}

export default MessageReadReceipt;
